/* eslint-disable max-len */
import React, {useState} from 'react';
import { HandleInputChange } from '../InputFeld/inputChange';
import UploadFileInput from '../UploadFileInput';
import Input from '../InputBox';

const UpdateDocument = ({
    state, 
    setstate, 
    setError,
    formatError, 
    setformatError,
    submitSelected,
    setsubmitSelected,
    customError,
}) => {
    const [imageLoading, setimageLoading] = useState('')

    /**
     * The function `handleOnchangeInput` is used to handle the change event of an input field,
     * specifically for the "pan_number" input field, and it updates the error state for "pan_number"
     * and "pan_validate" to false before calling the `HandleInputChange` function.
     */
    const handleOnchangeInput = (e) => {
        if(e.target.id === "pan_number") {

            setError((prevState) => ({ ...prevState, "pan_number": false, "pan_validate": false }));
        }
        HandleInputChange(e, setstate)
    }
    
    return (
        <>
            <div class="mt-[30px]">
                <h5 class="text-lg font-semibold text-[#000000] mb-2">Statutory Details</h5>
                <div className="border border-[#D0D5DD] rounded p-3">
                    <div className="-mx-[27px] flex flex-wrap">
                        <div className="px-[20px] w-1/2 mb-4">
                            <div className="w-full">
                                <div className="flex items-center -mx-2">
                                    <div className="w-[70%] px-2">
                                        <div className="flex items-center">
                                            <label for="pan-field" className="text-f7 font-normal text-[#031624] w-[35%] inline-flex pan_uploaded">PAN</label>
                                            <Input
                                                type="text"
                                                state={state}
                                                id="pan_number"
                                                maxLength={10}
                                                handleInput={handleOnchangeInput}
                                                submitSelected={submitSelected}
                                                setsubmitSelected={setsubmitSelected}
                                                isMandatoryField={true}
                                                text="PAN is mandatory"
                                                placeholder ="Enter PAN"
                                                customError={customError}
                                                inputWidth={`w-[68%]`}
                                            />
                                        </div>
                                    </div>
                                    <div className="px-2" style={{'width':'25%'}}>
                                        <div >
                                            <UploadFileInput
                                                mainKey="branch"
                                                state={state}
                                                id="pan_file_url"
                                                keyName="PAN"
                                                setsubmitSelected={setsubmitSelected}
                                                submitSelected={submitSelected}
                                                formatError={formatError}
                                                setstate={setstate}
                                                text="PAN is mandatory"
                                                setformatError={setformatError}
                                                setimageLoading={setimageLoading}
                                                placeholder="Upload PAN"
                                                imageLoading={imageLoading}
                                                classKey="w-full border border-[#D0D5DD] rounded py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#031624] err-border shadow-s7"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="px-[20px] w-1/2 mb-4">
                            <div className="w-full">
                                <div className="flex items-center -mx-2">
                                    <div className="w-[70%] px-2">
                                        <div className="flex items-center">
                                            <label htmlFor="registration_10_23c_certificate_number" className="text-f7 font-normal text-[#031624] w-[48%] inline-flex 10reg_uploaded">10(23C) Reg. No.</label>
                                            <Input
                                                optional
                                                type="text"
                                                state={state}
                                                maxLength={18}
                                                id="registration_10_23c_certificate_number"
                                                handleInput={handleOnchangeInput}
                                                submitSelected={submitSelected}
                                                setsubmitSelected={setsubmitSelected}
                                                placeholder="Enter 10(23C) Reg. No."
                                                text="10(23C) Registration is mandatory"
                                                inputWidth={`w-[68%]`}
                                            />
                                        </div>
                                    </div>
                                    <div className="px-2" style={{'width':'25%'}}>
                                        <UploadFileInput
                                            optional
                                            mainKey="branch"
                                            state={state}
                                            id="registration_10_23c_file_url"
                                            keyName="10(23C) Registration Certificate"
                                            submitSelected={submitSelected}
                                            formatError={formatError}
                                            setstate={setstate}
                                            text="10(23C) Registration is mandatory"
                                            setformatError={setformatError}
                                            setimageLoading={setimageLoading}
                                            placeholder="Upload 10(23C) Registration"
                                            imageLoading={imageLoading}
                                            classKey={`w-full  rounded py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#031624] err-border error-msg shadow-s7`}
                                        />
                                            
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="px-[20px] w-1/2 mb-4">
                            <div className="w-full">
                                <div className="flex items-center -mx-2">
                                    <div className="w-[70%] px-2">
                                        <div className="flex items-center">
                                            <label for="gstin-field" className="text-f7 font-normal text-[#031624] w-[35%] inline-flex gstin_uploaded">GSTIN</label>
                                            <Input
                                                optional
                                                type="text"
                                                state={state}
                                                id="gst_number"
                                                maxLength={15}
                                                handleInput={handleOnchangeInput}
                                                submitSelected={submitSelected}
                                                setsubmitSelected={setsubmitSelected}
                                                placeholder ="Enter GSTIN"
                                                customError={customError}
                                                inputWidth={`w-[68%]`}
                                            />
                                        </div>
                                    </div>
                                    <div className="px-2" style={{'width':'25%'}}>
                                        <div >
                                            <UploadFileInput
                                                optional
                                                mainKey="branch"
                                                state={state}
                                                id="gst_file_url"
                                                keyName="GSTIN"
                                                submitSelected={submitSelected}
                                                formatError={formatError}
                                                setstate={setstate}
                                                text="GSTIN is mandatory"
                                                setformatError={setformatError}
                                                setimageLoading={setimageLoading}
                                                placeholder="Upload GSTIN"
                                                imageLoading={imageLoading}
                                                classKey="w-full border border-[#D0D5DD] rounded py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#031624] err-border shadow-s7"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="px-[20px] w-1/2 mb-4">
                            <div className="w-full">
                                <div className="flex items-center -mx-2">
                                    <div className="w-[70%] px-2">
                                        <div className="flex items-center">
                                            <label for="pf-field" className="text-f7 font-normal text-[#031624] w-[48%] inline-flex gstin_uploaded">PF Reg. No.</label>
                                            <Input
                                                optional
                                                type="text"
                                                state={state}
                                                maxLength={20}
                                                id="pf_registration_certificate_number"
                                                handleInput={handleOnchangeInput}
                                                submitSelected={submitSelected}
                                                setsubmitSelected={setsubmitSelected}
                                                placeholder="Enter PF Reg. No."
                                                inputWidth={`w-[68%]`}
                                            />
                                        </div>
                                    </div>
                                    <div className="px-2" style={{'width':'25%'}}>
                                        <UploadFileInput
                                            optional
                                            mainKey="branch"
                                            state={state}
                                            id="pf_registration_file_url"
                                            keyName="10(23C) Registration Certificate"
                                            submitSelected={submitSelected}
                                            formatError={formatError}
                                            setstate={setstate}
                                            text="10(23C) Registration is mandatory"
                                            setformatError={setformatError}
                                            setimageLoading={setimageLoading}
                                            placeholder="Upload 10(23C) Registration"
                                            imageLoading={imageLoading}
                                            classKey="w-full border border-[#D0D5DD] rounded py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#031624] err-border error-msg shadow-s7"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="px-[20px] w-1/2 mb-4">
                            <div className="w-full">
                                <div className="flex items-center -mx-2">
                                    <div className="w-[70%] px-2">
                                        <div className="flex items-center">
                                            <label for="tan-field" className="text-f7 font-normal text-[#031624] w-[35%] inline-flex gstin_uploaded">TAN</label>
                                            <Input
                                                optional
                                                type="text"
                                                state={state}
                                                id="tan_number"
                                                maxLength={10}
                                                handleInput={handleOnchangeInput}
                                                submitSelected={submitSelected}
                                                setsubmitSelected={setsubmitSelected}
                                                placeholder="Enter TAN"
                                                inputWidth={`w-[68%]`}
                                            />
                                        </div>
                                    </div>
                                    <div className="px-2" style={{'width':'25%'}}>
                                        <UploadFileInput
                                            optional
                                            mainKey="branch"
                                            state={state}
                                            id="tan_file_url"
                                            keyName="TAN"
                                            submitSelected={submitSelected}
                                            formatError={formatError}
                                            setstate={setstate}
                                            text="TAN is mandatory"
                                            setformatError={setformatError}
                                            setimageLoading={setimageLoading}
                                            placeholder="Upload TAN"
                                            imageLoading={imageLoading}
                                            classKey="w-full border border-[#D0D5DD] rounded py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#031624] err-border shadow-s7"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="px-[20px] w-1/2 mb-4">
                            <div className="w-full">
                                <div className="flex items-center -mx-2">
                                    <div className="w-[70%] px-2">
                                        <div className="flex items-center">
                                            <label htmlFor="esi_registration_certificate_number" className="text-f7 font-normal text-[#031624] w-[48%] inline-flex gstin_uploaded">ESI Reg. No.</label>
                                            <Input
                                                optional
                                                type="text"
                                                state={state}
                                                maxLength={20}
                                                id="esi_registration_certificate_number"
                                                handleInput={handleOnchangeInput}
                                                submitSelected={submitSelected}
                                                setsubmitSelected={setsubmitSelected}
                                                placeholder="Enter ESI Reg. No."
                                                inputWidth={`w-[68%]`}
                                            />
                                        </div>
                                    </div>
                                    <div className="px-2" style={{'width':'25%'}}>
                                        <UploadFileInput
                                            optional
                                            mainKey="branch"
                                            state={state}
                                            id="esi_registration_file_url"
                                            keyName="ESI Registration Certificate"
                                            submitSelected={submitSelected}
                                            formatError={formatError}
                                            setstate={setstate}
                                            text="ESI Registration is mandatory"
                                            setformatError={setformatError}
                                            setimageLoading={setimageLoading}
                                            placeholder="Upload ESI Registration"
                                            imageLoading={imageLoading}
                                            classKey="w-full border border-[#D0D5DD] rounded py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#031624] err-border error-msg shadow-s7"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="px-[20px] w-1/2 mb-4">
                            <div className="w-full">
                                <div className="flex items-center -mx-2">
                                    <div className="w-[70%] px-2">
                                        <div className="flex items-center">
                                            <label for="12a-field" className="text-f7 font-normal text-[#031624] w-[35%] inline-flex gstin_uploaded">12A Reg. No.</label>
                                            <Input
                                                optional
                                                type="text"
                                                state={state}
                                                maxLength={20}
                                                id="registration_12a_certificate_number"
                                                // customError={!handlePanCheck()}
                                                handleInput={handleOnchangeInput}
                                                submitSelected={submitSelected}
                                                setsubmitSelected={setsubmitSelected}
                                                placeholder="Enter 12A Reg. No."
                                                inputWidth={`w-[68%]`}
                                            />
                                        </div>
                                    </div>
                                    <div className="px-2" style={{'width':'25%'}}>
                                        <UploadFileInput
                                            optional
                                            mainKey="branch"
                                            state={state}
                                            id="registration_12a_file_url"
                                            keyName="12A Registration Certificate"
                                            submitSelected={submitSelected}
                                            formatError={formatError}
                                            setstate={setstate}
                                            text="12A Registration is mandatory"
                                            setformatError={setformatError}
                                            setimageLoading={setimageLoading}
                                            placeholder="Upload 12A Registration"
                                            imageLoading={imageLoading}
                                            classKey="w-full border border-[#D0D5DD] rounded py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#031624] err-border error-msg shadow-s7"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="px-[20px] w-1/2 mb-4">
                            <div className="w-full">
                                <div className="flex items-center -mx-2">
                                    <div className="w-[70%] px-2">
                                        <div className="flex items-center">
                                            <label for="pt-field" className="text-f7 font-normal text-[#031624] w-[48%] inline-flex gstin_uploaded">PT Reg. No.</label>
                                            <Input
                                                optional
                                                type="text"
                                                state={state}
                                                maxLength={20}
                                                id="pt_registration_certificate_number"
                                                handleInput={handleOnchangeInput}
                                                submitSelected={submitSelected}
                                                setsubmitSelected={setsubmitSelected}
                                                placeholder="Enter PT Reg. No."
                                                inputWidth={`w-[68%]`}
                                            />
                                        </div>
                                    </div>
                                    <div className="px-2" style={{'width':'25%'}}>
                                        <UploadFileInput
                                            optional
                                            mainKey="branch"
                                            state={state}
                                            id="pt_registration_file_url"
                                            keyName="PT Registration Certificate"
                                            submitSelected={submitSelected}
                                            formatError={formatError}
                                            setstate={setstate}
                                            text="PT Registration is mandatory"
                                            setformatError={setformatError}
                                            setimageLoading={setimageLoading}
                                            placeholder="Upload PT Registration"
                                            imageLoading={imageLoading}
                                            classKey="w-full border border-[#D0D5DD] rounded py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#031624] err-border error-msg shadow-s7"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="px-[20px] w-1/2">
                            <div className="w-full">
                                <div className="flex items-center -mx-2">
                                    <div className="w-[70%] px-2">
                                        <div className="flex items-center">
                                            <label for="80g-field" className="text-f7 font-normal text-[#031624] w-[35%] inline-flex gstin_uploaded">80G Reg. No.</label>
                                            <Input
                                                optional
                                                type="text"
                                                state={state}
                                                maxLength={20}
                                                id="registration_80g_certificate_number"
                                                handleInput={handleOnchangeInput}
                                                submitSelected={submitSelected}
                                                setsubmitSelected={setsubmitSelected}
                                                placeholder="Enter 80G Reg. No."
                                                inputWidth={`w-[68%]`}
                                            />
                                        </div>
                                    </div>
                                    <div className="px-2" style={{'width':'25%'}}>
                                        <UploadFileInput
                                            optional
                                            mainKey="branch"
                                            state={state}
                                            id="registration_80g_file_url"
                                            keyName="80G Registration Certificate"
                                            submitSelected={submitSelected}
                                            formatError={formatError}
                                            setstate={setstate}
                                            text="80g Registration is mandatory"
                                            setformatError={setformatError}
                                            setimageLoading={setimageLoading}
                                            placeholder="Upload 80G Registration"
                                            imageLoading={imageLoading}
                                            classKey="w-full border border-[#D0D5DD] rounded py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#031624] err-border error-msg shadow-s7"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="px-[27px] w-1/2">
                            <div className="w-full">
                                <div className="flex items-center -mx-2">
                                    <div className="w-[70%] px-2">
                                        <div className="flex items-center">
                                            <label htmlFor="approval-field" className="text-f7 font-normal text-[#031624] w-[48%] inline-flex gstin_uploaded">Approval No.</label>
                                            <Input
                                                optional
                                                type="text"
                                                state={state}
                                                maxLength={20}
                                                id="approval_number"
                                                handleInput={handleOnchangeInput}
                                                submitSelected={submitSelected}
                                                setsubmitSelected={setsubmitSelected}
                                                placeholder="Enter Approval No."
                                                inputWidth={`w-[68%]`}
                                            />
                                        </div>
                                    </div>
                                    <div className="px-2" style={{'width':'25%'}}>
                                        <UploadFileInput
                                            optional
                                            mainKey="branch"
                                            state={state}
                                            id="approval_registration_file_url"
                                            keyName="Approval Certificate"
                                            submitSelected={submitSelected}
                                            formatError={formatError}
                                            setstate={setstate}
                                            text="Approval is mandatory"
                                            setformatError={setformatError}
                                            setimageLoading={setimageLoading}
                                            placeholder="Upload Approval Certificate"
                                            imageLoading={imageLoading}
                                            classKey="w-full border border-[#D0D5DD] rounded py-2.5 px-3.5 outline-0 placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal text-f2 font-normal text-[#031624] err-border error-msg shadow-s7"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </>
    );
}

export default UpdateDocument;
